import React, {Component} from 'react';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import { reduxForm } from 'redux-form';
import Dialog from 'infrastructure/js/components/Dialog/dialog';

import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import {gridsNames} from '../../../../enums/gridsNames.js';
import LabelCell from '../../Common/Cells/LabelCell/labelCell.js';
import {List} from 'immutable';
import Label from 'infrastructure/js/components/Label/label';
import MultiRowsCell from "infrastructure/js/components/Grid/MulitRowsCell/multiRowsCell";
import editableViewCell from "../../Common/Cells/InputCell/editableViewCell";
import PermissionManager from 'infrastructure/js/utils/permissionManager';

require('./SelectNestsStep.scss');

export class SelectNestsSecondStep extends React.PureComponent {

  constructor(props) {
    super(props);

    this.gridLabels = createLabelHelper(`mat.wizards.import.files.reportedCutsAndKits.grid.selectesnests.`);
    this.labels = createLabelHelper(`mat.wizards.import.files.importCutPlanWithRoll.`);
    this.columnsConfig = this.createColumnsConfig();
  }


  componentDidMount() {
    //todo - ran - review
    this.setIsRowDiabled();
  }

  createColumnsConfig = () => {
    let columnsConfig =  [
      {
        fieldName: 'nestBusinessId',
        title: this.gridLabels.get('columns.nest.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelCell,
          valueGetter: (params) => {
            return {errorMessage: params.data.errorPlan ,value: params.data.nestBusinessId, showOnlyError: false};
          },
        }
      },
      {
        fieldName: 'kitTypeBusinessId',
        title: this.gridLabels.get('columns.kittype.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return this.multiValueGetter(params, "kitTypeBusinessId", ["kitTypeBusinessIdError"], true);
          },
          sortable: false,
        }
      },
      {
        fieldName: 'kitBusinessId',
        title: this.gridLabels.get('columns.kitid.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return this.multiValueGetter(params, "kitBusinessId", ["lengthCutStringError", "tagKeyError"], false);
          },
          sortable: false,
        }
      },
      {
        fieldName: 'woBusinessId',
        title: this.gridLabels.get('columns.wo.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return this.multiValueGetter(params, "woBusinessId", ["woBusinessIdError"], true);
          },
          sortable: false,
        }
      },
      {
        fieldName: 'quantityPlies',
        title: this.gridLabels.get('columns.expectedplies.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return this.multiValueGetter(params, "quantityPlies");
          },
          sortable: false,
        }
      },
      {
        fieldName: 'quantityKittedPlies',
        title: this.gridLabels.get('columns.actualplies.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return this.actualPliesValueGetter(params);
          },
          editable: (params) => {
            return !params.data.isRowDisabled && !(params.data.nestWithRollFromFile?.every(item => item.isKitTypeHasPlies) ?? false)
          },
          cellEditor: 'editableMultiCell',
          cellEditorParams: {
            inputType: 'numeric',
            maxLength: 9999,
            isInt: true,
            shouldStopEditingOnBlur: false
          },
          onCellValueChanged: function (params) {
            params.data.nestWithRollFromFile.map((nestWithRoll, index) => {
              nestWithRoll.quantityKittedPlies = params.newValue.dataList[index].value;
            })
          },

          sortable: false,
        }
      },
      {
        fieldName: 'materialUsedAmount',
        title: this.gridLabels.get('columns.materialUsedAmount.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          cellComponent: MultiRowsCell,
          valueGetter: (params) => {
            return this.materialUsedAmountValueGetter(params);
          },
          editable: (params) => {
            return !params.data.isRowDisabled
          },
          cellEditor: 'editableMultiCell',
          cellEditorParams: {
            inputType: 'numeric',
            maxLength: 9999,
            shouldStopEditingOnBlur: false
          },
          onCellValueChanged: function (params) {
            params.data.nestWithRollFromFile.map((nestWithRoll, index) => {
              nestWithRoll.materialUsedAmount = params.newValue.dataList[index].value;
            })
          },
          sortable: false,
        }
      },
      ...(PermissionManager.hasScrapViewPermissions() ? [{
          fieldName: 'materialScrapAmount',
          title: this.gridLabels.get('columns.materialScrapAmount.title'),
          filterType: filterTypes.NONE,
          columnOptions: {
            cellComponent: MultiRowsCell,
            valueGetter: (params) => {
              return this.materialScrapAmountValueGetter(params);
            },
            editable: (params) => {
              return !params.data.isRowDisabled
            },
            cellEditor: 'editableMultiCell',
            cellEditorParams: {
              inputType: 'numeric',
              maxLength: 9999,
              shouldStopEditingOnBlur: false
            },
            onCellValueChanged: function (params) {
              params.data.nestWithRollFromFile.map((nestWithRoll, index) => {
                nestWithRoll.materialScrapAmount = params.newValue.dataList[index].value;
              })
            },
            sortable: false,
          }
        }] : [])
    ];

    return columnsConfig;
  };

  goOn = () => {
    var selectedNests = this.props.nestsItems.filter((nest) => {
      let isSelected = this.props.selectedNestsStepTwo.findIndex((selectedNest) => selectedNest.nestBusinessId === nest.nestBusinessId) != -1;
      nest.selected = isSelected;
      return isSelected;
    });
    this.props.actions.validateFile(this.props.sSelectedFile ,selectedNests)
  };

  goBack = () => {
    let wizardActions = this.props.wizardActions;
    wizardActions.previous();
  };

  onHide = () => {
    this.props.actions.onWizardClose();
    let wizardActions = this.props.wizardActions;
    wizardActions.close();
  };

  getDialogButtons() {
    let buttonOK = {
      id:'submit',
      text: this.labels.get('footer.selectnestsok'),
      bsStyle: 'primary',
      disabled: (this.props.sSelectedFile && !this.props.sNestsErrors && this.props.selectedNestsStepTwo.size > 0) ? this.props.loading : true,
      loading: this.props.loading,
      action: this.props.handleSubmit(this.goOn)
    };

    let buttonCancel = {
      id:'cancel',
      text: this.labels.get('footer.back'),
      action: this.goBack
    };

    return { left: [buttonCancel], right: [buttonOK] };
  }

  actualPliesValueGetter = (entity) => {
    return {
      dataList: entity.data?.quantityKittedPlies?.map((item, index) => {
        const isKitTypeHasPlies = entity.data.nestWithRollFromFile[index]?.isKitTypeHasPlies ?? false;
        return {
          enabled: !entity.data.isRowDisabled && !isKitTypeHasPlies,
          value: item,
          change: this.props.change,
        }
      }) || [],
      componentType: editableViewCell
    };
  };

  materialUsedAmountValueGetter = (entity) => {
    return {
      dataList: entity.data?.materialUsedAmount?.map((item) => {
        return {change:this.props.change, enabled: !entity.data.isRowDisabled, value: item}
      }) || [],
      componentType: editableViewCell
    };
  };

  materialScrapAmountValueGetter = (entity) => {
    return {
      dataList: entity.data?.materialScrapAmount?.map((item) => {
        return {change:this.props.change, enabled: !entity.data.isRowDisabled, value: item}
      }) || [],
      componentType: editableViewCell
    };
  };

  multiValueGetter = (entity, field, errorFields = List(), showOnlyError = false) => {
    return {
      dataList: entity.data.nestWithRollFromFile.map((item)=> {
        let errorMessage = "";
        let errorCount = 0;
        errorFields.map((errorField) => {
          if (item[errorField]) {
            if (errorCount > 0) {
              errorMessage = errorMessage.concat(", ")
            }

            errorMessage = errorMessage.concat(item[errorField]);
            errorCount++;
          }
        });

        return {
          value: item[field],
          errorMessage,
          showOnlyError,
        }
      }),
      componentType: LabelCell
    };
  }

  renderErrors = () => {
    if(this.props.sNestsErrors){
       return this.renderErrorSelection(this.props.sNestsErrors);
    }
    return null;
  }

  renderErrorSelection = (data) => {
     let icon = 'pl pl-warning-icon';
     let errorType = data.statusType;
      return (
        <div className="error-selection">
          <div className='error-item'>
              <span className={`error-icon ${icon} ${errorType}`}></span>
              <label className='error-msg'>{data.message}</label>
          </div>
        </div>
      );
  };

  getRowHeight = (params) => {
    let rowHeight = 64;
    let rowCount = params.data.nestWithRollFromFile ? params.data.nestWithRollFromFile.length : 0;
    if (rowCount > 1) {
      rowHeight = ((rowCount-1) * 45) + 64;
    }

    return rowHeight;
  };

  setIsRowDiabled = () => {
    if(this.props.selectedNests) {
       this.props.selectedNests.map((obj) => {
        obj.isRowDisabled = obj.hasErrorProperties;
      });
    }
  };

  render() {
    let animation = this.props.isFirstLaunch;
    let plan = this.props?.nestsItems[0]?.nestWithRollFromFile[0]?.plan;
    return (
      <Dialog
        id="select-nests-dialog"
        className="select-nests-dialog"
        animation={animation}
        show={true}
        onHide={this.onHide}
        titleText= {this.labels.get('selectnests.title')}
        moreInfoTextHeader={`${this.labels.get('filename.title')}: ${this.props.sSelectedFile ? this.props.sSelectedFile.name : ''}`}
        footerButtons={this.getDialogButtons()}
        handleHashChange={false}
      >
        <div>
          <Label text={`${this.labels.get('plan.title')}: ${plan ? plan : ''}`} tooltip={plan ? plan : ''}/>
        </div>

        <div className="select-nests-grid">
          <Grid gridName={gridsNames.IMPORT_NESTS_WITH_ROLL_SELECT_NESTS_STEP_TWO}
                columnsConfig={this.columnsConfig}
                rows={this.props.selectedNests}
                isStatic={true}
                gridProps={
                  {
                    shouldPreSelectRows:true,
                    getRowHeight: this.getRowHeight,
                    sideBar: false,
                  }
                }
          >

          </Grid>
        </div>

        {this.renderErrors()}

      </Dialog>
    );
  }
}

export default reduxForm({
    forceUnregisterOnUnmount: true,
    destroyOnUnmount: false
  }
)(SelectNestsSecondStep);

